<script setup>
import { handleReferrerTypeKey2Label } from "@/enum/referrerTypeEnum.js"
const props = defineProps({
  drawerCacheInfo: {
    required: true,
    type: Object,
    default: {}
  }
})
</script>

<template>
  <el-form label-position="right" label-width="auto">
    <el-form-item label="用户ID：">
      <span>{{props.drawerCacheInfo.memberId}}</span>
    </el-form-item>
    <el-form-item label="联系电话：">
      <span>{{props.drawerCacheInfo.phone}}</span>
    </el-form-item>
    <el-form-item label="微信ID：">
      <span>{{props.drawerCacheInfo.openid}}</span>
    </el-form-item>
    <el-form-item label="创建时间：">
      <span>{{props.drawerCacheInfo.crTime}}</span>
    </el-form-item>
    <el-form-item label="积分：">
      <span>{{props.drawerCacheInfo.availableCredit}}</span>
    </el-form-item>
    <el-form-item label="推荐人类型：">
      <span>{{handleReferrerTypeKey2Label(props.drawerCacheInfo.referrerType)}}</span>
    </el-form-item>
    <el-form-item label="推荐人ID：">
      <span>{{props.drawerCacheInfo.referrerId === "0" ? "-" : props.drawerCacheInfo.referrerId}}</span>
    </el-form-item>
    <el-form-item label="推荐人昵称：">
      <span>{{props.drawerCacheInfo.referrerNickname ? props.drawerCacheInfo.referrerNickname : "-"}}</span>
    </el-form-item>
  </el-form>
</template>

<style scoped>

</style>
